import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

import { computed, ComputedRef } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ValidationError',
  props: {
  name: {
    type: String,
    default: "",
  },
  errors: {
    type: Array,
    //default value for 'errors' prop must be a function
    default: () => [],
  },
},
  setup(__props) {

const props = __props;

const theErrors: ComputedRef<any[]> = computed(() => {
  return props.errors.filter((error: any) => {
    return error.name == props.name;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(theErrors.value, (error, i) => {
    return (_openBlock(), _createElementBlock("span", {
      key: error.name + i,
      class: "validation"
    }, _toDisplayString(error.value), 1))
  }), 128))
}
}

})